<script setup lang="ts">
import {Button, Dialog, Icon} from "@/Components/Library";
import Str from "@/Utils/Str.ts";
import {computed} from "vue";

const {questions, operationType} = defineProps<{
    questions: Array<{id: string; title: string; status: "pending" | "completed" | "error"}>;
    operationType: "duplicate" | "share";
}>();

const model = defineModel("visible", {type: Boolean, default: false});
const emit = defineEmits<{
    (e: "close"): void;
}>();

const headerText = computed(() => {
    return operationType === "duplicate" ? "Duplicating Posts" : "Sharing Posts";
});

const actionVerb = computed(() => {
    return operationType === "duplicate" ? "duplicated" : "shared";
});

const allCompleted = computed(() => {
    return questions.every((q) => q.status === "completed");
});

const handleClose = () => {
    model.value = false;
    emit("close");
};
</script>

<template>
    <Dialog v-model:visible="model" modal :header="headerText" class="w-full max-w-md">
        <p>You can close this popup at any time and we will notify you once your posts have been {{ actionVerb }}.</p>
        <div class="mt-2 flex flex-col gap-3">
            <template v-for="question in questions" :key="question.id">
                <div class="flex items-center justify-between gap-2 rounded-lg border p-3">
                    <span class="text-sm font-medium">{{ Str.of(question.title).truncate(40).value }}</span>
                    <div class="flex items-center">
                        <Icon
                            v-if="question.status === 'completed'"
                            icon="mdi:check-circle"
                            class="text-askr-green"
                            width="24"
                        />
                        <Icon
                            v-else-if="question.status === 'error'"
                            icon="mdi:close-circle"
                            class="text-red-600"
                            width="24"
                        />
                        <Icon v-else icon="svg-spinners:ring-resize" class="text-askr-green" width="24" />
                    </div>
                </div>
            </template>
        </div>
        <template #footer>
            <Button label="Close" class="w-full bg-askr-green text-white hover:brightness-110" @click="handleClose" />
        </template>
    </Dialog>
</template>

<style scoped></style>
